import axios from 'axios'

const Axios = axios.create({
    //  baseURL: 'http://192.168.10.202:81/api'
    //  baseURL: 'http://localhost:81/api'
   baseURL:'https://kpmtextile.com/service/api'
})

export default Axios